<div class="pnl-settings-design">
  <header>
    <a [routerLink]="['/app/configuracao']" class="back">Configurações</a>
    <h1>Design da loja</h1>
  </header>
  <section>
    <a [routerLink]="['personalizacao']" class="item">
      <strong>Personalização</strong>
      <span>Configure as cores/aparência de sua loja online</span>
    </a>

    <a [routerLink]="['banners']" class="item dnone">
      <strong>Banners</strong>
      <span>Adicione os banners que ficarão na sua página da loja online</span>
    </a>

    <a [routerLink]="['banner-rotativo']" class="item">
      <strong>Banner rotativo</strong>
      <span
        >Adicione os banners que ficarão rotacionando na página de entrada da
        loja online</span
      >
    </a>
  </section>
</div>
